import { groupByKey2 } from './group-by-key2';
import { groupArrayByRootKey } from './group-array-by-root-key';
import { unflattenObjToArray } from './unflatten-obj-to-arr';

export const hidrateArrayFromObjectKeys = (objToMap, splitBy = '/') =>
  groupByKey2(groupArrayByRootKey(unflattenObjToArray(objToMap, splitBy)));
